namespace RioERP.Masters {
    export interface LevelsForm {
        Name: Serenity.StringEditor;
        CourseId: Serenity.LookupEditor;
        SortOrder: Serenity.IntegerEditor;
    }

    export class LevelsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Levels';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LevelsForm.init)  {
                LevelsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(LevelsForm, [
                    'Name', w0,
                    'CourseId', w1,
                    'SortOrder', w2
                ]);
            }
        }
    }
}
